import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalProps: PropTypes.shape({
        item: PropTypes.shape({
            SourceDB: PropTypes.string,
            DestinationDB: PropTypes.string,
            TableName: PropTypes.string,
            Description: PropTypes.string,
        }),
    }).isRequired,
};

type UpdateAssetsActionDetailModalProps = PropTypes.InferProps<typeof propTypes>;

const UpdateAssetsActionDetailModal: React.FC<UpdateAssetsActionDetailModalProps> = ({
    isOpen,
    modalProps,
}: UpdateAssetsActionDetailModalProps) => {
    const dispatch = useDispatch();
    const hide = () => dispatch(hideModal("UPDATE_ASSETS_ACTION_DETAILS"));

    let title;
    let modalText;
    if (modalProps.item != null) {
        title = modalProps.item.TableName;
        modalText = (
            <div className="listForModal">
                <List dense>
                    <ListItem>
                        <ListItemText primary="Source DB: " secondary={modalProps.item.SourceDB} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Destination DB: " secondary={modalProps.item.DestinationDB} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Table Name: " secondary={modalProps.item.TableName} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Destination: " secondary={modalProps.item.Description} />
                    </ListItem>
                </List>
            </div>
        );
    }

    const modal = (
        <MaterialModal
            title={<span>{title || ""} Update Experian Assets Action Details</span>}
            isOpen={isOpen}
            onClose={hide}
            id="details-for"
            fullWidth
            maxWidth="xs"
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            {modalText || ""}
        </MaterialModal>
    );

    return modal;
};

export default withModal(UpdateAssetsActionDetailModal, "UPDATE_ASSETS_ACTION_DETAILS");
